module.exports = __webpack_public_path__ + "img/fleet.2611c2d1.svg";